export const logo = require("./logo.png")
export const logoAfds = require("./logo-afds.png")
export const logoFoodAngel = require("./logo-food-angel.png")
export const logoHkjcAllProject = require("./logo-hkjc-all-project.png")
export const logoHkjc = require("./logo-hkjc.png")
export const hkexLogo = require("./hkex-logo.png")
export const notData = require("./not-data.png")
export const iconLogo = require("./icon-logo.png")
